export const text = {
  en: {
    title: "Departments",
    subtitle: "Create, rename, merge departments and assign managers",
    unauthorized: "You don't have access to Departments",
    adminOnly: "Departments",
    company: "Company",
    allCompanies: "All companies",
    searchPlaceholder: "Search departments...",
    name: "Department",
    nameEn: "English name",
    nameAr: "Arabic name",
    members: "Members",
    managers: "Managers",
    noManagers: "No managers",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    showInactive: "Show inactive",
    actions: "Actions",
    newDepartment: "New Department",
    createTitle: "Create Department",
    editTitle: "Edit Department",
    descriptionLabel: "Description (optional)",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    rename: "Rename",
    deactivate: "Deactivate",
    deactivateConfirm: "Deactivate this department? Members keep their assignment; the department is hidden from pickers.",
    merge: "Merge",
    mergeTitle: "Merge Departments",
    mergeInto: "Merge the selected departments into:",
    mergeWarning: "Members, managers, visibility rules and workflows move to the target. Sources are deactivated. This also rewrites the legacy Employee Type values.",
    mergeSelectHint: "Select 2+ departments with the checkboxes, then click Merge.",
    confirmMerge: "Merge",
    membersTitle: "Members",
    noMembers: "No members",
    managersTitle: "Managers",
    manager: "Manager",
    deputy: "Deputy",
    addManager: "Add manager",
    suggested: "Suggested",
    suggestedManagerHint: "Most common first-line manager among members",
    managerCodePlaceholder: "Employee Infinity Code",
    remove: "Remove",
    saved: "Saved",
    error: "Error",
    success: "Success",
    createSuccess: "Department created",
    renameSuccess: "Department updated. Legacy Employee Type values were kept in sync.",
    mergeSuccess: "Merge completed",
    managersSuccess: "Managers updated",
    deactivateSuccess: "Department deactivated",
    loadError: "Failed to load departments",
    renameCascadeNote: "Renaming also updates every member's Employee Type and all rules using this department.",
    selectCompanyFirst: "Select a company to manage its departments",
    loading: "Loading departments...",
    empty: "No departments found",
    membersCount: (n) => `${n} member${n === 1 ? "" : "s"}`,
    departmentsCount: (n) => `${n} department${n === 1 ? "" : "s"}`,
    selectedCount: (n) => `${n} selected`,
    clearSelection: "Clear selection",
    employee: "Employee",
    employeeCode: "Employee Code",
    position: "Position",
    requestFailed: (status) => `Request failed (${status})`,
    emptySearch: "No departments match your search",
    emptyHint: "Create a department to start organizing employees.",
    mergeSources: "Departments to merge",
    nameRequired: "Department name is required",
    namePlaceholder: "e.g. Human Resources",
    nameArPlaceholder: "Department name in Arabic",
    descriptionPlaceholder: "Short description of the department",
    noManagersYet: "No managers assigned yet. Add one below.",
    viewMembers: "View members",
    statTotal: "Total Departments",
    statMembers: "Total Members",
    statWithManagers: "With Managers",
    statWithoutManagers: "Without Managers",
    searchAndFilter: "Search & Filter",
    findAndFilter: "Find departments by name, company or status",
    search: "Search",
    activeOnly: "Active only",
    includeInactive: "All (including inactive)",
    showingOf: (shown, total) => `Showing ${shown} of ${total}`,
    departmentsList: "Departments List",
    companyRequired: "Choose the company this department belongs to",
    mergeSameCompany: "Departments can only be merged within the same company.",
    managersSubtitle: "Choose who manages this department. A deputy acts on the manager's behalf.",
    selectEmployee: "Search by name or employee code",
    useCode: (code) => `Use employee code "${code}"`,
    noManagersTitle: "No managers yet",
    managersAssigned: (n) => `${n} assigned`,
  },
  ar: {
    title: "الأقسام",
    subtitle: "إنشاء الأقسام وإعادة تسميتها ودمجها وتعيين المديرين",
    unauthorized: "ليس لديك صلاحية الوصول إلى الأقسام",
    adminOnly: "الأقسام",
    company: "الشركة",
    allCompanies: "كل الشركات",
    searchPlaceholder: "ابحث عن قسم...",
    name: "القسم",
    nameEn: "الاسم بالإنجليزية",
    nameAr: "الاسم بالعربية",
    members: "الأعضاء",
    managers: "المديرون",
    noManagers: "لا يوجد مديرون",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    showInactive: "عرض غير النشط",
    actions: "إجراءات",
    newDepartment: "قسم جديد",
    createTitle: "إنشاء قسم",
    editTitle: "تعديل القسم",
    descriptionLabel: "الوصف (اختياري)",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    rename: "إعادة تسمية",
    deactivate: "إلغاء التفعيل",
    deactivateConfirm: "إلغاء تفعيل هذا القسم؟ يحتفظ الأعضاء بانتمائهم ويُخفى القسم من القوائم.",
    merge: "دمج",
    mergeTitle: "دمج الأقسام",
    mergeInto: "دمج الأقسام المحددة في:",
    mergeWarning: "سيتم نقل الأعضاء والمديرين وقواعد الرؤية وسير العمل إلى القسم الهدف، وإلغاء تفعيل الأقسام المصدر، مع تحديث قيم نوع الموظف القديمة.",
    mergeSelectHint: "حدد قسمين أو أكثر بمربعات الاختيار ثم اضغط دمج.",
    confirmMerge: "دمج",
    membersTitle: "الأعضاء",
    noMembers: "لا يوجد أعضاء",
    managersTitle: "المديرون",
    manager: "مدير",
    deputy: "نائب",
    addManager: "إضافة مدير",
    suggested: "مقترح",
    suggestedManagerHint: "المدير المباشر الأكثر شيوعاً بين الأعضاء",
    managerCodePlaceholder: "كود الموظف",
    remove: "إزالة",
    saved: "تم الحفظ",
    error: "خطأ",
    success: "نجاح",
    createSuccess: "تم إنشاء القسم",
    renameSuccess: "تم تحديث القسم مع مزامنة قيم نوع الموظف القديمة.",
    mergeSuccess: "تم الدمج بنجاح",
    managersSuccess: "تم تحديث المديرين",
    deactivateSuccess: "تم إلغاء تفعيل القسم",
    loadError: "فشل تحميل الأقسام",
    renameCascadeNote: "إعادة التسمية تُحدّث أيضاً نوع الموظف لكل الأعضاء وجميع القواعد المرتبطة بالقسم.",
    selectCompanyFirst: "اختر شركة لإدارة أقسامها",
    loading: "جارٍ تحميل الأقسام...",
    empty: "لا توجد أقسام",
    membersCount: (n) => (n === 0 ? "لا أعضاء" : n === 1 ? "عضو واحد" : n === 2 ? "عضوان" : n <= 10 ? `${n} أعضاء` : `${n} عضو`),
    departmentsCount: (n) => (n === 1 ? "قسم واحد" : n === 2 ? "قسمان" : n >= 3 && n <= 10 ? `${n} أقسام` : `${n} قسم`),
    selectedCount: (n) => `${n} محدد`,
    clearSelection: "إلغاء التحديد",
    employee: "الموظف",
    employeeCode: "كود الموظف",
    position: "المسمى الوظيفي",
    requestFailed: (status) => `فشل الطلب (${status})`,
    emptySearch: "لا توجد أقسام مطابقة للبحث",
    emptyHint: "أنشئ قسماً لبدء تنظيم الموظفين.",
    mergeSources: "الأقسام التي سيتم دمجها",
    nameRequired: "اسم القسم مطلوب",
    namePlaceholder: "اسم القسم بالإنجليزية",
    nameArPlaceholder: "مثال: الموارد البشرية",
    descriptionPlaceholder: "وصف مختصر للقسم",
    noManagersYet: "لم يتم تعيين مديرين بعد. أضف مديراً بالأسفل.",
    viewMembers: "عرض الأعضاء",
    statTotal: "إجمالي الأقسام",
    statMembers: "إجمالي الأعضاء",
    statWithManagers: "أقسام لها مديرون",
    statWithoutManagers: "أقسام بدون مدير",
    searchAndFilter: "البحث والتصفية",
    findAndFilter: "ابحث عن الأقسام بالاسم أو الشركة أو الحالة",
    search: "بحث",
    activeOnly: "النشطة فقط",
    includeInactive: "الكل (بما فيها غير النشطة)",
    showingOf: (shown, total) => `عرض ${shown} من ${total}`,
    departmentsList: "قائمة الأقسام",
    companyRequired: "اختر الشركة التي يتبعها هذا القسم",
    mergeSameCompany: "لا يمكن دمج الأقسام إلا داخل نفس الشركة.",
    managersSubtitle: "اختر من يدير هذا القسم. النائب يتصرف نيابةً عن المدير.",
    selectEmployee: "ابحث بالاسم أو كود الموظف",
    useCode: (code) => `استخدام كود الموظف "${code}"`,
    noManagersTitle: "لا يوجد مديرون بعد",
    managersAssigned: (n) => `${n} معيّن`,
  },
};
